import React from "react";
import "./styles.scss";
import { Text } from "atoms"

export default props => (
  <div className="feature-item">
    <img src={props.icon} alt="Feature icon"/>
    <Text h4 text={props.title}/>
    <Text p text={props.description}/>
  </div>
)
